'use strict';

var _ = require('lodash');
var UserManagementManageUsersTransformerFactory = function UserManagementManageUsersTransformerFactory(DataTransformer, User) {
  var ROLES_HIDDEN_ON_UI = 'INTERFACE';
  function UserManagementManageUsersTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'user-management-manage-users-mode';
  }
  UserManagementManageUsersTransformer.prototype = Object.create(DataTransformer.prototype);
  UserManagementManageUsersTransformer.constructor = UserManagementManageUsersTransformer;
  UserManagementManageUsersTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserManagementManageUsersTransformer.prototype.isCacheable = function () {
    return false;
  };
  UserManagementManageUsersTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserManagementManageUsersTransformer.prototype.transform = function (data) {
    return _.transform(data.domain.users, function (result, user) {
      if (!_.includes(user.roles[0], ROLES_HIDDEN_ON_UI)) {
        user.editable = true;
        user.userDisplayName = new User(user).getDisplayName();
        user.roles = user.roles.join(',');
        result.push(user);
      }
    }, []);
  };
  return UserManagementManageUsersTransformer;
};
UserManagementManageUsersTransformerFactory.$inject = ['DataTransformerFactory', 'UserFactory'];
module.exports = UserManagementManageUsersTransformerFactory;